import {Component, computed, signal} from '@angular/core';
import {CarouselModule} from 'primeng/carousel';
import {ButtonModule} from 'primeng/button';
import {Option, Question, TypeOption} from '@app/models';
import {HomeComponent, SlideComponent} from '@app/components';
import {ResultComponent} from '@app/components/result/result.component';
import {FormComponent} from '@app/components/form/form.component';
import {DisableSwipeDirective} from '@app/directives/disable-swipe.directive';
import {questions} from '@app/data/questions.data';

enum State {
  HOME = 'HOME',
  QUIZ = 'QUIZ',
  FORM = 'FORM',
  RESULT = 'RESULT'
}

@Component({
  selector: 'app-quiz',
  imports: [CarouselModule, ButtonModule, SlideComponent, HomeComponent, ResultComponent, FormComponent, DisableSwipeDirective],
  styleUrls: ['./quiz.component.scss'],
  templateUrl: './quiz.component.html'
})
export class QuizComponent {
  protected questions = signal<Question[]>([
    ...questions
  ]);

  protected state = signal<State>(State.HOME);
  protected currentIndex = signal(0); // Pilote la page du carousel
  protected answers = signal<Record<number, TypeOption>>({});

  protected result = computed(() => {
    const currentAnswers = Object.values(this.answers());

    if (currentAnswers.length === 0) {
      return TypeOption.A;
    }

    const counts = currentAnswers.reduce((acc, val) => {
      acc[val] = (acc[val] || 0) + 1;
      return acc;
    }, {} as Record<TypeOption, number>);

    return (Object.keys(counts) as TypeOption[]).reduce((a, b) =>
      counts[a] > counts[b] ? a : b
    );
  })

  protected startQuiz() {
    this.state.set(State.QUIZ);
  }

  protected seeResult() {
    this.state.set(State.RESULT);
  }

  protected next(choice: Option) {
    const currentId = this.questions()[this.currentIndex()].id;
    this.answers.update(prev => ({
      ...prev,
      [currentId]: choice.value
    }));

    if (this.currentIndex() < this.questions().length - 1) {
      this.currentIndex.update(v => v + 1);
    } else {
      this.state.set(State.FORM);
    }
  }

  protected prev() {
    if (this.currentIndex() > 0) {
      this.currentIndex.update(v => v - 1);
    } else {
      this.state.set(State.HOME)
    }
  }

  protected home() {
    this.currentIndex.update(v => 0);
    this.state.set(State.HOME)
  }

  protected readonly State = State;
}
